import React, { useEffect } from 'react'
import { updateShownStatusQuickNotification, useReturnQuickNotification } from './notificationsSlice'
import Slide, { SlideProps } from '@mui/material/Slide';
import Snackbar from '@mui/material/Snackbar';
import { Alert, Button, IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';
import GenerateIcon from '../../components/GenerateIcon';
import AlertElement from '../../components/AlertElement';

export type QuickNotificationTypes = "error" | "info" | "success"

export interface IQuickNotificationButton {
    label: string,
    variant?: 'text' | 'outlined' | 'contained',
    color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
    onClick?: () => void,
    handleClose: boolean
}

export interface IQuickNotification {
    shown: boolean,
    message: string,
    type: QuickNotificationTypes,
    handleBeforeClose?: () => void,
    autoHideDuration?: number,
    disableAautoHideDuration?: boolean,
    customActionButtons?: Array<IQuickNotificationButton>
}

function SlideTransition(props: SlideProps) {
    return <Slide {...props} direction="up" />;
  }

export default function QuickNotification() {

    const dispatch = useDispatch()

    const notification = useReturnQuickNotification()

    const handleClose = () => dispatch(updateShownStatusQuickNotification({ status: false }))

    const defaultActionButtons: Array<IQuickNotificationButton> = [
        {
            label: "Close",
            handleClose: true
        }
    ]
    const actionButtons: Array<IQuickNotificationButton> = notification.customActionButtons && notification.customActionButtons.length > 0 ? notification.customActionButtons : defaultActionButtons

    useEffect(() => {
        if (notification.shown){
            if (notification.handleBeforeClose){
                notification.handleBeforeClose()
            }

            if (!notification.disableAautoHideDuration){
                setTimeout(() => handleClose(), notification.autoHideDuration ? notification.autoHideDuration : 4000)
            }

        }
    }, [notification.shown])

    return(
        <Snackbar
            open={notification.shown}
            onClose={() => {}}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            security="error"
        >
            {/* <Alert
                severity={notification.type}
                variant="filled"
                sx={{ width: '100%' }}
                // onClose={(e) => handleClose()}
                className="quick-notification-alert"
            >
                {notification.message}

                <IconButton><GenerateIcon icon="close" /></IconButton>
            </Alert> */}
            <div className={`quick-notification-snackbar-box ${notification.type} hide-for-print`}>
                <div className="content-of-quick-notification-snackbar-box">

                    <div className="icon-box-of-quick-notification-snackbar-box">
                        <div className="content-of-icon-box-of-quick-notification-snackbar-box">
                            <GenerateIcon icon={notification.type} />
                        </div>
                    </div>

                    <div className="text-box-of-quick-notification-snackbar-box">
                        <div className="content-of-text-box-of-quick-notification-snackbar-box">
                            <p>{notification.message}</p>
                        </div>
                    </div>

                    <div className="action-buttons-of-quick-notification-snackbar-box">
                        <div className="content-of-action-buttons-of-quick-notification-snackbar-box">
                            {actionButtons.map((button, index) => <Button key={index} color={button.color ? button.color : "inherit"} onClick={() => {
                                if (button.onClick){
                                    button.onClick()
                                    handleClose()
                                }else{
                                    handleClose()
                                }
                            }} className={"general-button admin-style"} variant={button.variant ? button.variant : "text"} >{button.label}</Button>)}
                        </div>
                    </div>

                </div>
            </div>
        </Snackbar>
    )
}